module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicWide-Bold-cb8bfd20653ffd9d8df9f3df265a128a.woff2";